/* src/app/shared/components/fixed-bottom-bar/fixed-bottom-bar.component.scss */
.centerBar {
  display: flex;
  justify-content: center;
}
.centerBar .bottomBar {
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border: solid;
  border-color: #dfdfdf;
  border-width: 1px;
  display: flex;
  z-index: 1;
  position: fixed;
  bottom: 0;
  justify-content: space-between;
  width: 1220px;
  height: 104px;
  background-color: #ffffff;
}
.centerBar .bottomBar .textArea {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  margin-left: 32px;
  margin-top: 26px;
  margin-bottom: 24px;
}
.centerBar .bottomBar .textArea .header {
  color: #222222;
  font-family: "Poppins-Regular";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  margin-bottom: 0;
}
.centerBar .bottomBar .textArea .body {
  color: #a6a6a6;
  font-family: "Poppins-Regular";
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.centerBar .bottomBar .buttonArea {
  display: inline-flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 24px;
  margin-bottom: 24px;
  margin-right: 32px;
}
/*# sourceMappingURL=fixed-bottom-bar.component.css.map */
